const COLOR = {
  PRIMARY: '#2C7BE5',
  TEXT_COLOR: '#121212',
  TEXT_COLOR_SECONDARY: '#4D4D4D',
  TEXT_COLOR_SPECIAL: '#AC8C67',
  DARK_BTN_SECONDARY: '#244166',
  TEXT_COLOR_MENU: '#4D4D4D',
  BACKGROUND_SECTION_TEXT: '#F7F5F1',
  SUCCESS: '#17CD6E',
  BLACK: '#000',
  WHITE: '#F9FAFC',
  DARK_BG_MAIN: '#121212',
  DARK_GRAY: '#8492A6',
  DARK_BG_PRIMARY: '#121212',
  DARK_BG_SECONDARY: '#1B242F',
  DARK_BG_FOOTER: '#121820',
  DARK_TEXT_COLOR: '#9FA4A9',
  DARK_TEXT_COLOR_SECONDARY: '#9FA4A9',
  DARK_TEXT_COLOR_MENU: '#9FA4A9',
  DARK_BACKGROUND_SECTION_TEXT: '#201E1B',
};

export default COLOR;
